import React, {useState, useContext} from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';

import CartoucheSeance from 'components/CartoucheSeance';
import Context from 'utils/Context';

import Register from './Register';
import Login from './Login';


const SeanceLogin = ({open, seance, onLogin, onClose}) => {
  const [mode, setMode] = useState('login');
  const {appState, modele, methods} = useContext(Context);

  return (
    <Dialog open={open} scroll="body" className="my-dialog">
      <DialogContent>
        <CartoucheSeance hideBtns seance={seance} appState={appState} modele={modele} />
      </DialogContent>
      {mode === 'login' ? (
        <Login
          onSwitchToRegister={() => {
            setMode('register');
          }}
          methods={methods}
          onClose={onClose}
          onLogin={onLogin}
        />
      ) : (
        <Register onClose={onClose} onLogin={onLogin} />
      )}
    </Dialog>
  );
};

export default SeanceLogin;
